
import Util from '@/lib/grip.util.js';
// 재정 Mixin
export default {
	data() {
        return {
            // 기금 특별회계 코드
            // 410: 자활, 411: 옥외광고물정비기금, 420: 노인복지, 425: 식품진흥, 430: 재난관리
            specialFundCodes: ['412', '414', '440', '450', '410', '420', '415', '411', '425', '455', '413', '460', '430', '416', '445'],
            
        };
	},
	components: {
		Util
	},
    computed: {
        selectedFinance() {
            return this.$store.getters.getSelectedFinance;
        },
        expenditureList() {
            return this.$store.getters.getExpenditureList;
        },
        quickExpenditureList() {
            return this.$store.getters.getQuickExpenditureList;
        },
        expenditureSearchList() {
            return this.$store.getters.getExpenditureSearchList;
        },
        expenditureYearList() {
            return this.$store.getters.getExpenditureYearList;
        },
        expenditureDetailList() {
            return this.$store.getters.getExpenditureDetailList;
        },
        selectedExpenditureField() {
            return this.$store.getters.getSelectedExpenditureField;
        },
        // 일반 회계 세출
        commonExpenditureList() {
            let commonExpenditureList = this.expenditureList.filter(expenditure => {
                return !this.specialFundCodes.includes(expenditure.val1);
            });
            
            commonExpenditureList = commonExpenditureList.sort((first, second) => {
                return Number(second.val13) - Number(first.val13);
            });
            
            return commonExpenditureList;
        },
        // 기금 특별 회계 세출
        specialFundExpenditureList() {
            return this.expenditureList.filter(expenditure => {
                return this.specialFundCodes.includes(expenditure.val1);
            });
        },
        
        commonExpenditureSearchList() {
            let commonExpenditureList = this.expenditureSearchList.filter(expenditure => {
                return !this.specialFundCodes.includes(expenditure.val1);
            });
            
            commonExpenditureList = commonExpenditureList.sort((first, second) => {
                return Number(second.val13) - Number(first.val13);
            });
            
            return commonExpenditureList;
        },
        specialFundExpenditureSearchList() {
            return this.expenditureSearchList.filter(expenditure => {
                return this.specialFundCodes.includes(expenditure.val1);
            });
        },
        
        revenueList() {
            return this.$store.getters.getRevenueList;
        },
        quickExecList() {
            return this.$store.getters.getQuickExecList;
        },
        selectedRevenueFgCd() {
            return this.$store.getters.getSelectedRevenueFgCd;
        },
        showBizListWin() {
            return this.$store.getters.getShowBizListWin;
        },
        showBizDetailWin() {
            return this.$store.getters.getShowBizDetailWin;
        },
        bizDetailUrl() {
            return this.$store.getters.getBizDetailUrl;
        },
        showQuickExecWin() {
            return this.$store.getters.getShowQuickExecWin;
        },
        
        expenditureFieldList() {
            let fieldList = [];
            const fieldMap = {};
            
            // 일반 회계 세출 구성
            this.commonExpenditureList.forEach(expenditure => {
                if(typeof fieldMap[expenditure.val18] === 'undefined') {
                    fieldMap[expenditure.val18] = {
                        fldCd: expenditure.val18,
                        fldNm: expenditure.val19,
                        compoAmt: Number(expenditure.val22),
                        compoAmtUnit: undefined,
                        expdAmt: Number(expenditure.val17),
                        expdAmtUnit: undefined,
                        expdRatio: 0,
                        totalRatio: 0,
                    };
                    
                    fieldList.push(fieldMap[expenditure.val18]);
                } else {
                    fieldMap[expenditure.val18].compoAmt += Number(expenditure.val22);
                    fieldMap[expenditure.val18].expdAmt += Number(expenditure.val17);
                }
            });
            // 예비비 제외
            fieldList = fieldList.filter(data => {
                return data.fldCd !== '160'
            });

            fieldList = fieldList.sort((first, second) => {
                return second.compoAmt - first.compoAmt;
            });
            
            // // 기금 특별 회계 세출 구성
            // const specialFundFldCd = '000';
            // let specialFundField = {
            //     fldCd: specialFundFldCd,
            //     fldNm: '기금특별회계',
            //     compoAmt: 0,
            //     compoAmtUnit: undefined,
            //     expdAmt: 0,
            //     expdAmtUnit: undefined,
            //     expdRatio: 0,
            //     totalRatio: 0,
            // };
            // fieldList.push(specialFundField);
            // fieldMap[specialFundFldCd] = specialFundField;
            // this.specialFundExpenditureList.forEach(expenditure => {
            //     fieldMap[specialFundFldCd].compoAmt += Number(expenditure.val22);
            //     fieldMap[specialFundFldCd].expdAmt += Number(expenditure.val17);
            // });  
            
            // 억 천만 단위 분리 및 집행액 비율 계산
            fieldList.forEach(field => {
                field.compoAmtUnit = Util.separateCurrencyUnit(field.compoAmt);
                field.expdAmtUnit = Util.separateCurrencyUnit(field.expdAmt);
                if(field.compoAmt != 0) {
                    field.expdRatio = Math.round((field.expdAmt / field.compoAmt) * 100);
                }
                field.totalRatio = Math.round(Number(field.compoAmt) / Number(this.totalCommonExpenditure) * 10000) / 100;
            });
            return fieldList;      
        },
    },
    
    methods: {
        popupBizListWin(isShow) {
            this.$store.dispatch('SET_SHOW_BIZ_LIST_WIN', isShow);
        },
        popupQuickExecWin(isShow) {
            this.$store.dispatch('SET_SHOW_QUICK_EXEC_WIN', isShow);
        },
    }
}